import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBgR6pSF4CDK65XyfjEBypZx4JpgNF-Mo0",
  authDomain: "vrsimracersmanager.firebaseapp.com",
  projectId: "vrsimracersmanager",
  storageBucket: "vrsimracersmanager.firebasestorage.app",
  messagingSenderId: "646232742711",
  appId: "1:646232742711:web:3ed92a5ccd6f2d81ee18b2",
  measurementId: "G-LFE4JW6LVE"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);